// extracted by mini-css-extract-plugin
export default {"link":"styles_link__ajw9Z","linkButton":"styles_linkButton__CjGGl","label":"styles_label__1Y+rl"};